<script>
import { mapState } from 'vuex'

export default{
  data: ()=>({
    cityoptions: [],
    streetoptions: [],
    houseoptions: [],
    realcityoptions: [],
    realstreetoptions: [],
    realhouseoptions: [],
    client: {
      address: {
        city: '',
        city_kladr_id: '',  
        street: '',
        street_kladr_id: '',
        house: '',
        house_kladr_id: '',
        index: ''
      },
      realaddress: {
        city: '',
        city_kladr_id: '',  
        street: '',
        street_kladr_id: '',
        house: '',
        house_kladr_id: '',
        index: ''
      },
    },
    suggestionsData: {},    
    realsuggestionsData: {},
  }),
  computed: {
    ...mapState(['DaDataToken','DaDataUrl']),
    kladrdata:{
      get(){
        let a = this.client.address, ra = this.client.realaddress,
        c = 'city_kladr_id', s = 'street_kladr_id', h = 'house_kladr_id', i = 'index'
        return {
          [c]: a[c],
          [s]: a[s],
          [h]: a[h],
          ['_dadata_'+i]: a[i], 
          [`real${c}`]: ra[c],
          [`real${s}`]: ra[s],
          [`real${h}`]: ra[h],
          [`_dadata_real${i}`]: ra[i],
        }
      },
      cache: false
    }
  },
  watch:{
    kladrdata:{
      handler(v){
        this.stepsdata[this.number].dadatainfo = v
      },
      deep: true
    },
  },
  methods: {
    resetSuggestions(){
      this.client =  {
        address: {
          city: '',
          city_kladr_id: '',  
          street: '',
          street_kladr_id: '',
          house: '',
          house_kladr_id: '',
          index: ''
        },
        realaddress: {
          city: '',
          city_kladr_id: '',  
          street: '',
          street_kladr_id: '',
          house: '',
          house_kladr_id: '',
          index: ''
        },
      }
    },
    nullifyStreetDaData(real) {
      let key = real? 'realaddress': 'address'
      this.client[key].street = ''
      this.client[key].street_kladr_id = ''
      this.client[key].house = ''
      this.client[key].house_kladr_id = ''
      this.client[key].index = ''
    },
    setKladrFromDDI(DDI){
      let a = this.client.address, ra = this.client.realaddress,
      c = 'city_kladr_id', s = 'street_kladr_id', h = 'house_kladr_id', i = 'index'
      a[c] = DDI[c]
      a[s] = DDI[s]
      a[h] = DDI[h]
      a[i] = DDI['_dadata_index']
      ra[c] = DDI[`real${c}`]
      ra[s] = DDI[`real${s}`]
      ra[h] = DDI[`real${h}`]
      ra[i] = DDI['_dadata_realindex']
    },
    async citySuggest(query, real){
      let addr = 'address'
      let sdata = 'suggestionsData'
      if (real) {
        addr = 'realaddress'
        sdata = 'realsuggestionsData'
      }
      this.client[addr].city_kladr_id = ''
      this.client[addr].street = ''
      this.client[addr].street_kladr_id = ''
      this.client[addr].house = ''
      this.client[addr].index = ''
      this.client[addr].house_kladr_id = ''
      this.client[addr].flat = ''

      let url = this.DaDataUrl,
          token = this.DaDataToken,
          options =  {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({query: query, count: 5,
                  "locations": [{"country": "Россия"}],
                  "to_bound": { "value": "settlement" },})
          }
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=> res.suggestions.filter(el=>el.data && (el.data.city_kladr_id || el.data.settlement_kladr_id)))
                        .catch(()=>[]))
      this[sdata].cities = sg
      if (query && this[sdata].cities) {
        let city = this[sdata].cities . find(c=>c.value==query)
        if (city) {
          this.client[addr].city_kladr_id = city . data . city_kladr_id || city . data . settlement_kladr_id
          this[sdata].city = city.data.city
          this[sdata].settlement = city.data.settlement
        }
      }      
      return sg.map(el=>el.value)
    },
    async streetSuggest(query, real){
      let addr = 'address'
      let sdata = 'suggestionsData'
      if (real) {
        addr = 'realaddress'
        sdata = 'realsuggestionsData'
      }    
      this.client[addr].street_kladr_id = ''
      this.client[addr].house = ''
      this.client[addr].house_kladr_id = ''
      this.client[addr].index = ''
      this.client[addr].flat = ''    
      let limit = 0
      while (!this.client[addr].city_kladr_id) {
        await new Promise(r => setTimeout(r, 500))
        if (++limit == 10) return []
      }
      let url = this.DaDataUrl,
          token = this.DaDataToken,
          options =  {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: {
                  query: query, 
                  count: 5,
                  "from_bound": { "value": "street" },
                  "to_bound": { "value": "street" },
                  "locations": [{"kladr_id": this.client[addr].city_kladr_id}],
                  "restrict_value": true
                  }
          }
          if (this[sdata].city)
            options.body.locations[0].city = this[sdata].city
          if (this[sdata].settlement) 
            options.body.locations[0].settlement = this[sdata].settlement
          options.body = JSON.stringify(options.body)
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=> res.suggestions.filter(el=>el.data && el.data.street_kladr_id))
                        .catch(()=>[]))

      this[sdata].streets = sg
      if (query && this[sdata].streets) {
        let street = this[sdata].streets . find(c=>c.value==query)
        if (street) 
          this.client[addr].street_kladr_id = street . data . street_kladr_id
      }      
      return sg.map(el=>el.value)
    },
    async houseSuggest(query, real, nostreet){
      let addr = 'address'
      let sdata = 'suggestionsData'
      if (real) {
        addr = 'realaddress'
        sdata = 'realsuggestionsData'
      }
      this.client[addr].house_kladr_id = ''
      this.client[addr].flat = ''     
      let limit = 0
      let area_kladr_id = this.client[addr].street_kladr_id
      if (nostreet)
        area_kladr_id = this.client[addr].city_kladr_id

      while (!area_kladr_id) {
        await new Promise(r => setTimeout(r, 500))
        if (++limit == 10) return []
      }
          
      let url = this.DaDataUrl,
          token = this.DaDataToken,
          options =  {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: {
                  query: query, 
                  count: 5,
                  "from_bound": { "value": "house" },
                  "to_bound": { "value": "house" },
                  "locations": [{"kladr_id": area_kladr_id}],
                  "restrict_value": true
                  }
          }
          if (this[sdata].city)
            options.body.locations[0].city = this[sdata].city
          if (this[sdata].settlement) 
            options.body.locations[0].settlement = this[sdata].settlement
          options.body = JSON.stringify(options.body)
      let sg = await (fetch(url, options)
                        .then(response => response.json())
                        .then(res=> res.suggestions.filter(el=>el.data && el.data.house_kladr_id && (nostreet? !el.data.street_kladr_id : el.data.street_kladr_id)))
                        .catch(()=>[]))

      this[sdata].houses = sg
      if (query && this[sdata].houses) {
        let house = this[sdata].houses . find(c=>c.value==query)
        if (house) {
          this.client[addr].house_kladr_id = house . data . house_kladr_id
          this.client[addr].index = house. data . postal_code
        }
      }
      return sg.map(el=>el.value)
    },  
  }
}
</script>